import { createContext, useContext } from "react";

export type TeamWorkspaceFrame = {
  fullScreen: boolean;
  toggleFullScreen: () => void;
  minimize: () => void;
  blocked: boolean;
  /** Called by the page's controls; while none is registered the window renders its own. */
  register: () => () => void;
  controlsMounted: boolean;
};
export const TeamWorkspaceFrameContext = createContext<TeamWorkspaceFrame | null>(null);
export function useTeamWorkspaceFrame() { return useContext(TeamWorkspaceFrameContext); }
